let last = 0

export const uniqueId = (prefix = 'id', separator = '-') => `${prefix}${separator}${last++}`